module.exports = {
  ChainIdMatic: '0x89',
  ChaiIdEthereum: '0x1',
  ChaiIdBinance: '0x38',
  ChaiIdAvalanche: '0xa86a',
  ChaiIdArbitrum: '0xa4b1',
  ChaiIdBase: '0x2105',
  ChaiIdAurora: '0x4e454152',
  ChaiIdCronos: '0x19',
  ChaiIdTron: '0x2b6653dc',
  ChaiIdOP: '0xa',
  ChaiIdZk: '0x144',
  ChaiIdMetis: '0x440',
  ChaiIdHyperEvm: '0x3e7',
  ChaiIdSonic: '0x92',
  PROJECTID: '15542c28ab0bb325c503e39971a06f2c',
  infiAddress: '0x0CC9b5290d920bDC966E93205241D0eE07b5799f',
  polygonProvider:
    'https://polygon-mainnet.g.alchemy.com/v2/EHguAo4U2tTY-vTkE0WsDZ0vd0_Azhug',
};
